import { createFileRoute } from '@tanstack/react-router';

import ChangePassword from '@/ui/pages/ChangePassword/ChangePassword';

/**
 * The mandatory password change after a temporary-password sign-in (HS-1225).
 *
 * Deliberately **not** in `PUBLIC_PATHS`: the root guard lets this path through only while the
 * session is in `passwordChangeRequired`, and bounces it to `/login` otherwise. That is the
 * whole access rule — the page needs no guard of its own.
 *
 * The reload hole this file used to document is closed. `passwordChangeRequired` is still
 * in-memory, but `authClient`'s `restore` operation re-asserts it from the `tokenManager` flag
 * whenever `/Auth/me` answers on the cookie the 301 login set, so a reload lands back here
 * instead of inside the panel with the temporary password still in place. Two callers reach this
 * screen now — a `/login` sign-in and the lab-onboarding flows, which authenticate through their
 * own endpoint and hand the session over with `requirePasswordChange`.
 */
export const Route = createFileRoute('/change-password')({
  component: ChangePassword,
});
